export const productShortName = 'Chemistry — Teacher Ready';
export const productBrand = 'Chemistry';
export const productEdition = 'Teacher Ready';
export const productTag = 'Chemistry · Teacher Ready';
export const productImage = 'https://cdn.magicpatterns.com/uploads/2z9VT2UctzDYzEvdZHQPb1/MOCKUP_CHEMISTRY.png';
export const productImageAlt =
  'Chemistry — Teacher Ready 6-volume teaching collection: matter and atomic structure, periodic table and bonding, reactions and the mole, acids, bases and equilibrium, organic chemistry and polymers, lab safety and practical skills, plus five bonus resources';

export const checkoutUrl = 'https://chemistry-teacher-ready.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusValue = 'USD 14.00';
export const bonusTotalValue = 'USD 70.00';

export const closingLines = [
  'No more building every chemistry lesson from scratch',
  'No more hunting for diagrams of atoms, bonds and reactions across the internet',
  'No more students lost between atoms, ions, equations and moles',
  'No more unclear guidance for safe practical work',
  'No more planning a chemistry course without a clear structure',
];
